const headerSection = {
  mainHeading:
    'Making India a world leader in Virtual reality and Augmented reality',
  secondHeading:
    "VR and AR are changing the way we experience, create and learn We're building an ecosystem to accelerate this change"
}

const moreSection = {
  Revenue: {
    mainHeading: 'AR & VR Revenue ',
    secondHeading: 'to hit $108 Billion by 2021',
    description:
      'With AR & VR penetrating into diverse sectors and impacting lifestyle of many, these technologies are going to disrupt the industry with a CAGR 94.3% from $3.9 billion in 2016 to $108 billion by 2021. ',
    mainImage:
      'https://s3-eu-west-1.amazonaws.com/newsletter-static-media/vr_site/for_section/graph.png',
    webpsrc:
      'https://d1ov0p6puz91hu.cloudfront.net/AR-VR/Backgrounds/graph.webp',
    link: '/learners',
    alt: 'ib VR AR Revenue Graph',
    applyText: '',
    areahidden: 'none'
  },
  Learners: {
    mainHeading: 'For Learners',
    secondHeading: 'Build your career in VR/AR',
    description:
      'VR allows users to experience a different world giving unmatched amount of freedom for creators. As the industry is growing at 94.3%, so are the career opportunities. Applications of VR/AR are limitless.',
    want: 'Want to get started?',
    apply: 'Apply Now',
    link: '/learners',
    mainImage: '/assets/images/ForLearners/forlearners.png',
    alt: 'ib VR AR Learners',
    imagesPath: '/assets/images/ForLearners/',
    applyText: 'Apply Now',
    areahidden: ''
  },
  GamePublish: {
    mainHeading: 'For Game Publishers',
    secondHeading: 'Fast track your success!',
    description:
      'With our widely established global and PAN India VR/AR Ecosystem, you can gain traction exponentially and expand at scale. Deep dive into the product development and leave the rest to us.',
    want: 'Want to connect with us?',
    apply: 'Apply Now',
    link: '/game-developers',
    mainImage: '/assets/images/ForGamePublish/gamepublishers.png',
    alt: 'ib VR AR Game Publishers',
    imagesPath: '/assets/images/ForGamePublish/',
    applyText: 'Apply Now',
    areahidden: ''
  },
  Organisations: {
    mainHeading: 'For Organizations',
    secondHeading:
      'Get assistance with VR/AR technology for better business outcomes.',
    description:
      'Organisations across domains can use this technology in enhancing their products or services, capacity building and improving productivity of employees, giving immersive demos, visualizing data, rapid prototyping and testing, and many more.',
    want: 'Want assistance in building VR/AR products for you?',
    apply: 'Apply Now',
    link: '/business',
    mainImage:
      'https://s3-eu-west-1.amazonaws.com/newsletter-static-media/vr_site/for_section/oraganizations.jpg',
    alt: 'ib VR AR Organisations',
    imagesPath: '/assets/images/ForOrganisations/',
    applyText: 'Get in Touch',
    areahidden: ''
  }
}

const coreTeam = {
  mainHeading: 'Core Team',
  secondHeading:
    'Our core team members are alumni of best colleges of India and are set out to make iB as one of the world’s leading company in VR/AR Industry',
  bottomContent:
    'We are supported by 1000 highly talented youngsters from national and international institutions of whom 150 are working full time.Majority of us are alumni of premier institutes like IITs, IIMs and corporate alumni of major MNCs.'
}

const shareVision = {
  mainHeading: 'Share your vision for the future'
}

const LaunchingProductDetails = {
  image: 'https://d1ov0p6puz91hu.cloudfront.net/AR-VR/iBC-Logo.png',
  mainHeading: 'iB CRICKET',
  subHeading: 'Launching our First Product...',
  description:
    "A world's first of its kind <b>VR Cricket Sport</b> with the most immersive cricketing game-play experience."
}

export default {
  headerSection,
  moreSection,
  coreTeam,
  shareVision,
  LaunchingProductDetails
}



// WEBPACK FOOTER //
// ./src/components/TeamNew/FollowUsSection/utilities/data.js